import React, { useContext, useEffect } from 'react'
import CheckoutOverview from 'app/React/Components/Main/CheckoutOverview'
import EnvInput from 'app/React/Components/EnvInput'
import EnvDateInput from 'app/React/Components/EnvDateInput'
import EnvZipCodeInput from 'app/React/Components/EnvZipCodeInput'
import Price from 'app/React/Components/Footer/Price'
import IsCash from 'app/React/Components/misc/IsCash'
import PaymentRadio from 'app/React/Components/Form/PaymentRadio'
import LocationField from 'app/React/Components/Form/LocationField'
import ShowReservationField from 'app/React/Components/misc/ShowReservationField'
import PaymentTerms from 'app/React/Components/Form/PaymentTerms'
import Newsletter from 'app/React/Components/Form/Newsletter'
import { getStepInfo } from 'utils/getStepInfo'
import DealerCheckoutOverview from 'app/React/Components/Main/DealerCheckoutOverview'
import IsNotDealerConfigurator from 'app/React/Components/misc/IsNotDealerConfigurator'
import IsDealerConfigurator from 'app/React/Components/misc/IsDealerConfiguration'
import IsNotDealerConfiguratorOrDealerCustomerOrder
  from 'app/React/Components/misc/IsNotDealerConfiguratorOrDealerCustomerOrder'
import ErrorMessage from 'app/React/Components/misc/ErrorMessage'
import TradePaymentRadio from "app/React/Components/Form/TradePaymentRadio";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";
import IsDealerConfiguratorAnd from "app/React/Components/misc/IsDealerConfigurationAnd";

export default function Step5() {
  const {
    isAccessoryShop,
    cartItems,
    currentEngineTransmission,
    currentVariant,
    dealerEmail,
    dealerNumberOptions,
    dealerDebitorNumbers,
    dealerDebitorEmails,
    dealerPbvSpecificDebitorNumbers,
    isDealerConfigurator,
    isGlobalDownPaymentCash,
    isStorageOrderHandled,
    order,
    showPlateFieldAccessoryIds,
    strings,
    usePrice,
    useSecurityDeposit,
    vehicleType,
    setOrder,
    zipCodes
  } = useContext(ConfiguratorContext)

  const dealerNumber = order.dealer_number ?? ''
  const dealerOrderType = order.dealer_order_type ?? ''
  const dealerVehicleType = order.dealer_vehicle_type ?? ''
  const steps = currentVariant?.steps ?? {}
  const paymentStrings = strings.payment_form ?? {}
  const stepInfo = getStepInfo(steps, '5')

  const restPaymentAmount = usePrice() - useSecurityDeposit()

  const restPaymentOptions = isGlobalDownPaymentCash
    ? [
      {
        label: paymentStrings.global_rest_payment.finance,
        description: '',
        value: 'finance'
      },
      {
        label: paymentStrings.global_rest_payment.cash,
        description: '',
        value: 'cash'
      }
    ]
    : [
      {
        label: paymentStrings.rest_payment.cash,
        description: (<Price price={restPaymentAmount} format='cash' />),
        value: 'cash'
      },
      {
        label: paymentStrings.rest_payment.finance,
        description: paymentStrings.rest_payment.finance_description,
        value: 'finance'
      }
    ]

  const displayRestpayment = Boolean(Number(currentVariant?.steps?.[5]?.show_restpayment ?? '0'))
  const displayServiceAgreement = Boolean(Number(currentVariant?.steps?.[5]?.show_service_deal ?? '0'))
  const displayTradein = Boolean(Number(currentVariant?.steps?.[5]?.show_tradein ?? '0'))
  const displayInsurance = Boolean(Number(currentVariant?.steps?.[5]?.show_insurance ?? '0'))
  const displayDealer = Boolean(Number(currentVariant?.steps?.[5]?.show_dealer ?? '0'))
  const displayAccessoryShopPlate = () => {
    if (!isAccessoryShop) {
      return false
    }

    for (let i = 0; i < cartItems.length; i++) {
      if (showPlateFieldAccessoryIds.includes(cartItems[i].id)) {
        return true
      }
    }

    return false
  }

  const getFilteredDealerNumberOptions = () => {
    return dealerNumberOptions
      .filter(x => {
        if (!currentVariant.hasOwnProperty('b2b_open_internal')) {
          return true
        }

        if (!currentVariant.b2b_open_internal) {
          return true
        }

        return dealerDebitorEmails.includes(dealerEmail)
      })
      .filter(x => {
        if (!currentVariant.hasOwnProperty('pbv_specific')) {
          return true
        }

        if (currentVariant.pbv_specific == '0') {
          return true
        }

        return dealerPbvSpecificDebitorNumbers.includes(x.value)
      })
  }

  const getCompanyCarValue = () => {
    if (typeof dealerEmail !== 'string' || dealerEmail.length === 0) {
      return null
    }

    const initials = dealerEmail.split('@')[0].toUpperCase()
    const dealerName = dealerNumberOptions.find(dealer => dealer.value === dealerNumber)?.label

    return 'Firmabil ' + initials + ', ' + dealerName
  }

  let dealerOrderTypes = [
    {
      label: paymentStrings.dealer_order_type?.customer_car,
      description: paymentStrings.dealer_order_type?.customer_car_description,
      value: 'customer_car'
    },
    {
      label: paymentStrings.dealer_order_type?.consignment_warehouse,
      description: paymentStrings.dealer_order_type?.consignment_warehouse_description,
      value: 'consignment_warehouse'
    },
    {
      label: paymentStrings.dealer_order_type?.demo_car,
      description: paymentStrings.dealer_order_type?.demo_car_description,
      value: 'demo_car'
    }
  ]

  if (dealerDebitorNumbers.length > 0 && dealerDebitorNumbers.includes(dealerNumber)) {
    dealerOrderTypes.push({
      label: paymentStrings.dealer_order_type?.internal_cars,
      description: paymentStrings.dealer_order_type?.internal_cars_description,
      value: 'internal_cars'
    })

    dealerOrderTypes.push({
      label: paymentStrings.dealer_order_type?.company_car,
      description: paymentStrings.dealer_order_type?.company_car_description,
      value: 'company_car'
    })
  }

  let dealerVehicleTypes = []

  if (currentEngineTransmission?.hasOwnProperty('price') && typeof currentEngineTransmission?.price === 'number') {
    dealerVehicleTypes.push({
      label: paymentStrings.dealer_vehicle_type.person_type,
      description: paymentStrings.dealer_vehicle_type.person_type_description,
      value: 'person'
    })
  }

  if (currentEngineTransmission?.hasOwnProperty('van_price') && typeof currentEngineTransmission?.van_price === 'number') {
    dealerVehicleTypes.push({
      label: paymentStrings.dealer_vehicle_type.van_type,
      description: paymentStrings.dealer_vehicle_type.van_type_description,
      value: 'van'
    })
  }

  if (vehicleType === 'isuzu') {
    dealerVehicleTypes.push({
      label: paymentStrings.dealer_vehicle_type.special_use_type,
      description: paymentStrings.dealer_vehicle_type.special_use_type_description,
      value: 'special_use'
    })
    dealerVehicleTypes.push({
      label: paymentStrings.dealer_vehicle_type.crew_car_type,
      description: paymentStrings.dealer_vehicle_type.crew_car_type_description,
      value: 'crew_car'
    })
  }

  useEffect(() => {
    if (isStorageOrderHandled !== true) {
      return
    }

    const availableDealerOrderTypes = dealerOrderTypes.map(dealerOrderType => dealerOrderType.value)
    let newDealerOrderType = dealerOrderType

    if (!availableDealerOrderTypes.includes(dealerOrderType)) {
      newDealerOrderType = availableDealerOrderTypes[0]
    }

    const isDealerVehicleTypeHidden = isDealerConfigurator && dealerOrderType !== 'customer_car' && dealerOrderType !== 'demo_car' && dealerOrderType !== 'consignment_warehouse'
    let newDealerVehicleType = dealerVehicleType

    if (!isDealerVehicleTypeHidden) {
      const availableDealerVehicleTypes = dealerVehicleTypes.map(dealerVehicleType => dealerVehicleType.value)

      if (!availableDealerVehicleTypes.includes(dealerVehicleType)) {
        newDealerVehicleType = availableDealerVehicleTypes[0]
      }
    } else {
      newDealerVehicleType = ''
    }

    order.dealer_order_type = newDealerOrderType
    order.dealer_vehicle_type = newDealerVehicleType

    if (order.dealer_order_type === 'company_car') {
      order.internal_cars_name = ''
    }

    setOrder({ ...order })
  }, [isStorageOrderHandled, dealerNumber, dealerOrderType])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div id='step-5'>
      <div className='config-form'>
        <div className='config-form__inner'>
          <h2 className='config-title'>{stepInfo?.alternative_title ?? stepInfo.title}</h2>
          <IsNotDealerConfigurator>
            {typeof stepInfo.subtitle === 'string' && stepInfo.subtitle.length > 0 ? (
              <div
                className='description'
                dangerouslySetInnerHTML={{ __html: stepInfo.subtitle }}
              />
            ) : null}
          </IsNotDealerConfigurator>

          <div className='config-form__errors'>
            <ErrorMessage field='order_line_error' scrollToTop/>
            <ErrorMessage field='dealer_id' scrollToTop/>
            <ErrorMessage field='sales_person' scrollToTop/>
            <ErrorMessage field='sales_person_email' scrollToTop/>
          </div>

          <div className='config-form__inputs'>
            <IsDealerConfigurator>
              {
                getFilteredDealerNumberOptions()
                  .length > 1
                  ? <PaymentRadio
                    name='dealer_number'
                    title={paymentStrings.dealer_number?.label}
                    tip={paymentStrings.dealer_number?.tip}
                    optionLayout={'standard-third'}
                    options={getFilteredDealerNumberOptions()}
                  />
                  : null
              }

              <PaymentRadio
                name='dealer_order_type'
                title={paymentStrings.dealer_order_type?.label}
                tip={paymentStrings.dealer_order_type?.tip}
                optionLayout={'standard-third'}
                options={dealerOrderTypes}
              />

              {
                isDealerConfigurator && dealerOrderType !== 'customer_car' && dealerOrderType !== 'demo_car' && dealerOrderType !== 'consignment_warehouse'
                  ? null
                  : <PaymentRadio
                    name='dealer_vehicle_type'
                    title={paymentStrings.dealer_vehicle_type.label}
                    tip={paymentStrings.dealer_vehicle_type.tip}
                    optionLayout={'standard-third'}
                    options={dealerVehicleTypes}
                  />
              }
            </IsDealerConfigurator>

            <IsDealerConfiguratorAnd dealerOrderTypes={['internal_cars']}>
              <div className='config-form__input'>
                <label htmlFor='internal_cars_name' className='config-form__input-label'>
                  {paymentStrings.labels.name}
                </label>
                <EnvInput
                  id='internal_cars_name'
                  name='internal_cars_name'
                  placeholder={paymentStrings.placeholders.name}
                  autoComplete='given-name'
                  required={false}
                />
              </div>
            </IsDealerConfiguratorAnd>

            <IsDealerConfiguratorAnd dealerOrderTypes={['company_car']}>
              <div className='config-form__input'>
                <label htmlFor='company_car_name' className='config-form__input-label'>
                  {paymentStrings.labels.name}
                </label>
                <input
                  id='company_car_name'
                  name='company_car_name'
                  type='text'
                  placeholder={paymentStrings.placeholders.name}
                  autoComplete='given-name'
                  required={false}
                  readOnly
                  value={getCompanyCarValue()}
                />
              </div>
            </IsDealerConfiguratorAnd>

            <IsNotDealerConfiguratorOrDealerCustomerOrder>
              <h2 className='config-form__subtitle'>
                {paymentStrings.dealer_vehicle_type?.form_title}
              </h2>

              <div className='config-form__input config-form__input--half'>
                <label htmlFor='first_name' className='config-form__input-label'>
                  {paymentStrings.labels.first_name}
                </label>
                <EnvInput
                  id='first_name'
                  name='first_name'
                  placeholder={paymentStrings.placeholders.first_name}
                  autoComplete='given-name'
                />
              </div>

              <div className='config-form__input config-form__input--half'>
                <label htmlFor='last_name' className='config-form__input-label'>
                  {paymentStrings.labels.last_name}
                </label>
                <EnvInput
                  id='last_name'
                  name='last_name'
                  placeholder={paymentStrings.placeholders.last_name}
                  autoComplete='family-name'
                />
              </div>

              <div className='config-form__input'>
                <label
                  htmlFor='street_address'
                  className='config-form__input-label'
                >
                  {paymentStrings.labels.address}
                </label>
                <EnvInput
                  id='street_address'
                  name='street_address'
                  placeholder={paymentStrings.placeholders.address}
                  autoComplete='street-address'
                />
              </div>

              <div className='config-form__input config-form__input--half'>
                <EnvZipCodeInput
                  label={paymentStrings.labels.zip}
                  placeholder={paymentStrings.placeholders.zip}
                />
              </div>

              <div className='config-form__input config-form__input--half'>
                <label
                  htmlFor='city_address'
                  className='config-form__input-label'
                >
                  {paymentStrings.labels.city}
                </label>
                <EnvInput
                  id='city_address'
                  name='city_address'
                  placeholder={paymentStrings.placeholders.city}
                  autoComplete='address-level2'
                  readOnly={Object.keys(zipCodes).length !== 0}
                  tabIndex={Object.keys(zipCodes).length !== 0 ? -1 : 0}
                />
              </div>

              <div className='config-form__input config-form__input--half'>
                <label htmlFor='telephone' className='config-form__input-label'>
                  {paymentStrings.labels.phone}
                </label>
                <EnvInput
                  id='telephone'
                  name='telephone'
                  placeholder={paymentStrings.placeholders.phone}
                  type='tel'
                  autoComplete='tel'
                />
              </div>

              <div className='config-form__input config-form__input--half'>
                <label htmlFor='email' className='config-form__input-label'>
                  {paymentStrings.labels.email}
                </label>
                <EnvInput
                  id='email'
                  name='email'
                  placeholder={paymentStrings.placeholders.email}
                  type='email'
                  autoComplete='email'
                />
              </div>

              <IsDealerConfigurator>
                <div className='config-form__input config-form__input--half'>
                  <label htmlFor='delivery_date' className='config-form__input-label'>
                    {paymentStrings.labels.delivery_date}
                  </label>
                  <EnvDateInput
                    id='delivery_date'
                    name='delivery_date'
                    placeholder={paymentStrings.placeholders.delivery_date}
                    type='date'
                  />
                </div>
              </IsDealerConfigurator>

              <ShowReservationField>
                <div className='config-form__input'>
                  <label
                    htmlFor='reservations_number'
                    className='config-form__input-label'
                  >
                    {paymentStrings.labels.reservations_number}
                  </label>
                  <EnvInput
                    id='reservations_number'
                    name='reservations_number'
                    type='number'
                    placeholder={paymentStrings.placeholders.reservations_number}
                    required={false}
                  />
                </div>
              </ShowReservationField>

            </IsNotDealerConfiguratorOrDealerCustomerOrder>
          </div>

          <IsNotDealerConfiguratorOrDealerCustomerOrder>
            <div className='config-form__separator'/>
          </IsNotDealerConfiguratorOrDealerCustomerOrder>

          <IsNotDealerConfigurator>
            {displayTradein ? (
              <TradePaymentRadio/>
            ) : null}

            <IsCash>
              {displayRestpayment ? (
                <PaymentRadio
                  name='rest_payment'
                  title={isGlobalDownPaymentCash ? paymentStrings.global_rest_payment.label : paymentStrings.rest_payment.label}
                  tip={isGlobalDownPaymentCash ? paymentStrings.global_rest_payment.tip : paymentStrings.rest_payment.tip}
                  options={restPaymentOptions}
                />
              ) : null}
            </IsCash>

            {displayAccessoryShopPlate() ? (
              <>
                <div className='config-form__input'>
                  <label
                    htmlFor='reservations_number'
                    className='config-form__input-label'
                  >
                    {paymentStrings.labels.accessory_shop_plate}
                  </label>
                  <EnvInput
                    id='accessory_shop_plate'
                    name='accessory_shop_plate'
                    placeholder={paymentStrings.placeholders.accessory_shop_plate}
                    required={true}
                  />
                </div>

                <div className='config-form__separator'/>
              </>
            ) : null}

            {displayInsurance ? (
              <PaymentRadio
                name='insurance'
                title={paymentStrings.insurance.label}
                tip={paymentStrings.insurance.tip}
                showChildren={(value) => value === 'no'}
                visibleChildrenValue='no'
                options={[
                  {
                    label: paymentStrings.insurance.offer,
                    description: paymentStrings.insurance.offer_description,
                    value: 'yes'
                  },
                  {
                    label: paymentStrings.insurance.insurance,
                    description: paymentStrings.insurance.insurance_description,
                    value: 'no'
                  }
                ]}
              >
                <div className='config-form__separator-transparent'/>
                <div className='config-form__inputs'>
                  <label htmlFor='insurer' className='config-form__input-label'>
                    {paymentStrings.labels.insurer}
                  </label>
                  <EnvInput
                    id='insurer'
                    name='insurer'
                    placeholder={paymentStrings.placeholders.insurer}
                    required={false}
                  />
                </div>
              </PaymentRadio>
            ) : null}

            <IsCash>
              {displayServiceAgreement ? (
                <PaymentRadio
                  name='service_agreement'
                  title={paymentStrings.service_agreement.label}
                  tip={paymentStrings.service_agreement.tip}
                  options={[
                    {
                      label: paymentStrings.service_agreement.yes,
                      value: 'yes'
                    },
                    {
                      label: paymentStrings.service_agreement.no,
                      value: 'no'
                    }
                  ]}
                />
              ) : null}
            </IsCash>

            {displayDealer ? (
              <LocationField
                title={paymentStrings.location.label}
                tip={paymentStrings.location.tip}
              />
            ) : null}

            <PaymentTerms/>

            <Newsletter/>

          </IsNotDealerConfigurator>
        </div>
      </div>
      <IsNotDealerConfigurator>
        <CheckoutOverview/>
      </IsNotDealerConfigurator>
      <IsDealerConfigurator>
        <DealerCheckoutOverview/>
      </IsDealerConfigurator>
    </div>
  )
}
